export function clamp(num, min, max = null) {
  const clampLower = Math.max(num, min);
  if (typeof max === 'number') return Math.min(clampLower, max);else return clampLower;
}